/*
* 当前系统时间操作（与 CRM dateHelper 一致）
*/
var dateHelper = {
    getYearList() {
        var start = 2017;
        var end = new Date().getFullYear() + 5;
        var list = [];
        for (var i = 0; i <= end - start; i++) {
            list.push(start + i);
        }
        return list;
    }
};
export default dateHelper;
